import styled from 'styled-components'
import { Formik, Form, Field } from 'formik'
import PropTypes from 'prop-types'

import Button from 'components/Atoms/Button'
import Text from 'components/Atoms/Text'
import { PhoneField } from 'components/Molecules/Form'

import validationSchema from './validationSchema'

const Component = styled(Form)`
  margin-top: 30px;
  margin-bottom: 30px;
`

const Label = styled(Text)`
  margin-bottom: 6px;
`

const PhoneNumberBox = styled.div`
  display: flex;
`

const PhoneNumber = styled(PhoneField)`
  flex: 1;
`

const NextButton = styled(Button)`
  margin-left: 8px;
  margin-top: 4px;
  padding: 0 20px;
  height: 44px;
`

const Screen = props => {
  const {
    country,
    error,
    handleSubmit,
    initialValues,
    onFocusField,
    phoneNumberRef,
    formikRef,
    t,
  } = props

  return (
    <Formik
      ref={formikRef}
      initialValues={initialValues}
      onSubmit={handleSubmit}
      validationSchema={() => validationSchema(country)}
      render={props => {
        const { isSubmitting, setSubmitting, setStatus } = props

        return (
          <Component>
            <Label className="large semiBold">
              {t('downloadApp.default.phoneNumber.label')}
            </Label>
            <PhoneNumberBox>
              <Field
                inputRef={phoneNumberRef}
                component={PhoneNumber}
                disabled={isSubmitting && !error}
                name="phoneNumber"
                placeholder={t('downloadApp.default.phoneNumber.placeholder')}
                onFocus={() => onFocusField(setSubmitting, setStatus)}
              />
              <NextButton disabled={isSubmitting && !error} type="submit">
                {t('downloadApp.default.phoneNumber.button').toUpperCase()}
              </NextButton>
            </PhoneNumberBox>
          </Component>
        )
      }}
    />
  )
}

Screen.propTypes = {
  country: PropTypes.string,
  error: PropTypes.string,
  handleSubmit: PropTypes.func,
  initialValues: PropTypes.object,
  isSubmitting: PropTypes.bool,
  onFocusField: PropTypes.func,
  setStatus: PropTypes.bool,
  setSubmitting: PropTypes.bool,
  phoneNumberRef: PropTypes.object,
  formikRef: PropTypes.object,
  t: PropTypes.func,
}

export default Screen
